export default __webpack_public_path__ + "static/media/device-EV932873.cd6f09f1.png";